export interface AnalyticsData {
  followers: {
    count: number;
    growth: number;
    history: {
      date: string;
      count: number;
    }[];
  };
  engagement: {
    rate: number;
    history: {
      date: string;
      rate: number;
    }[];
    bestTimes: {
      hour: number;
      engagement: number;
    }[];
  };
  sentiment: {
    positive: number;
    neutral: number;
    negative: number;
    keywords: {
      word: string;
      count: number;
    }[];
  };
  posts: {
    total: number;
    performance: {
      id: string;
      type: string;
      engagement: number;
      reach: number;
      clicks: number;
      conversions: number;
      roi?: number;
    }[];
  };
}

export const generateAnalytics = (platform: string): AnalyticsData => {
  // Simula dados de analytics
  const today = new Date();
  const history = Array.from({ length: 30 }, (_, i) => {
    const date = new Date();
    date.setDate(today.getDate() - (29 - i));
    return {
      date: date.toISOString(),
      count: 1000 + Math.floor(Math.random() * 100) + (i * 10),
      rate: 2 + Math.random() * 3
    };
  });

  const bestTimes = Array.from({ length: 24 }, (_, i) => ({
    hour: i,
    engagement: 1 + Math.random() * 4
  }));

  const currentCount = history[history.length - 1].count;
  const previousCount = history[0].count;
  const growth = ((currentCount - previousCount) / previousCount) * 100;

  const postTypes = ['foto', 'carrossel', 'vídeo', 'stories'];
  const performance = Array.from({ length: 20 }, (_, i) => ({
    id: `post-${i + 1}`,
    type: postTypes[Math.floor(Math.random() * postTypes.length)],
    engagement: Math.random() * 100,
    reach: Math.floor(Math.random() * 10000),
    clicks: Math.floor(Math.random() * 1000),
    conversions: Math.floor(Math.random() * 100),
    roi: Math.random() * 500
  }));

  return {
    followers: {
      count: currentCount,
      growth,
      history: history.map(({ date, count }) => ({ date, count }))
    },
    engagement: {
      rate: history[history.length - 1].rate,
      history: history.map(({ date, rate }) => ({ date, rate })),
      bestTimes
    },
    sentiment: {
      positive: 65,
      neutral: 25,
      negative: 10,
      keywords: [
        { word: 'excelente', count: 45 },
        { word: 'ótimo', count: 32 },
        { word: 'incrível', count: 28 },
        { word: 'perfeito', count: 25 },
        { word: 'recomendo', count: 20 }
      ]
    },
    posts: {
      total: performance.length,
      performance
    }
  };
};
